import * as swcHelpers from '@swc/helpers';
import { getLocalizedString } from '@grandvisionhq/utils';
import { toBaseLineItem } from './base-line-item.js';
import { isContactLensBundleTypeDetails } from './utils/cart-line-item-product-type-guards.js';
import { getLineItemImageUrl } from '../../../utils/get-line-item-image-url.js';
import { getAttribute } from '../../../utils/get-line-item-attribute.js';

const isBundledSolutionLineItem = (bundledLineItem)=>{
    return bundledLineItem.type === 'SOLUTION';
};
const toContactLensesBundleCartLineItem = (cartLineItem, intl, settings)=>{
    var ref, ref1, ref2;
    const base = toBaseLineItem(cartLineItem, settings, intl);
    const mainBundleLineItem = cartLineItem.bundleLineItems.find((bundleLineItem)=>bundleLineItem.isMainBundleLineItem
    );
    const bundledSolutionLineItem = (ref = cartLineItem.bundleLineItems) === null || ref === void 0 ? void 0 : ref.find(isBundledSolutionLineItem);
    const typeDetails = cartLineItem.typeDetails && isContactLensBundleTypeDetails(cartLineItem.typeDetails) && cartLineItem.typeDetails;
    const prescription = !typeDetails ? undefined : {
        leftEye: Object.fromEntries(Object.entries(typeDetails.prescription.leftLens).map(([key, value])=>[
                key,
                value ? value.toString() : null, 
            ]
        )),
        rightEye: Object.fromEntries(Object.entries(typeDetails.prescription.rightLens).map(([key, value])=>[
                key,
                value ? value.toString() : null, 
            ]
        ))
    };
    const imageUrl = (mainBundleLineItem === null || mainBundleLineItem === void 0 ? void 0 : mainBundleLineItem.legacyProduct.masterData.current.variant) ? getLineItemImageUrl(mainBundleLineItem === null || mainBundleLineItem === void 0 ? void 0 : mainBundleLineItem.legacyProduct.masterData.current.variant, settings.staticsUrl, settings.isBynderImagesEnabled) : '';
    return swcHelpers.objectSpread({}, base, {
        type: 'CONTACT_LENS_BUNDLE',
        productType: 'contact-lenses-bundle-benelux',
        imageUrl,
        title: getLocalizedString(mainBundleLineItem === null || mainBundleLineItem === void 0 ? void 0 : mainBundleLineItem.legacyProduct.masterData.current.name, intl.locale),
        subtitle: `${intl.getLabel('products.monthlySubscription')} ${mainBundleLineItem ? getAttribute(mainBundleLineItem === null || mainBundleLineItem === void 0 ? void 0 : mainBundleLineItem.legacyProduct.masterData.current.variant, 'lensType') : ''}`,
        altText: getLocalizedString(mainBundleLineItem === null || mainBundleLineItem === void 0 ? void 0 : mainBundleLineItem.legacyProduct.masterData.current.name, intl.locale),
        prescription,
        bundleChildLineItems: bundledSolutionLineItem ? [
            {
                title: intl.getLabel('facets.productType.solutions'),
                body: getLocalizedString(bundledSolutionLineItem.legacyProduct.masterData.current.name, intl.locale),
                price: ((ref1 = bundledSolutionLineItem.price) === null || ref1 === void 0 ? void 0 : ref1.total.gross) || 0,
                originalPrice: ((ref2 = bundledSolutionLineItem.price) === null || ref2 === void 0 ? void 0 : ref2.total.subtotal) || 0
            }, 
        ] : undefined
    });
};

export { toContactLensesBundleCartLineItem };
//# sourceMappingURL=contact-lenses-bundle-line-item.js.map
